import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import lngs from "../../lngs";
import HomeIcon from "@mui/icons-material/Home";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import ChecklistIcon from "@mui/icons-material/Checklist";
const AppBottomBar = () => {
  const {
    t,
    i18n
  } = useTranslation("operations");
  const location = useLocation();
  const currentLang = i18n.resolvedLanguage;
  const isLanguageRTL = lngs[currentLang]?.isRtl || false;
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("profile")));
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);
  const isApp = location.pathname.toLowerCase().includes("/app/");
  const isModernPOSTerminal = location.pathname.toLowerCase().includes("/app/pos/terminal/");
  if (!user || !isApp || isModernPOSTerminal) return null;
  const currentYear = new Date().getFullYear();
  const isRouteActive = path => location.pathname.toLowerCase().includes(path.toLowerCase());
  return <div className="app-bottom-bar np" dir={isLanguageRTL ? "ltr" : "rtl"}>
      <div className="abb-brand">
        <img src="/logo.svg" alt={t("logo")} style={{
        height: "35px"
      }} />
        <span className="abb-brand-text">
          © {currentYear}{t("Quantum Billing")}</span>
      </div>

      <div className="abb-links" style={{
      direction: isLanguageRTL ? "rtl" : "ltr",
      flexDirection: "row"
    }}>
        <Link to={`/${currentLang}/app/main`} className={`abb-link ${isRouteActive("/app/main") ? "abb-link-active" : ""}`}>
          <HomeIcon fontSize="small" />
          <span>{t("home")}</span>
        </Link>

        <Link to={`/${currentLang}/app/dashboard`} className={`abb-link ${isRouteActive("/app/dashboard") ? "abb-link-active" : ""}`}>
          <DashboardIcon fontSize="small" />
          <span>{t("dashboard")}</span>
        </Link>

        <Link to={`/${currentLang}/app/todos`} className={`abb-link ${isRouteActive("/app/todos") ? "abb-link-active" : ""}`}>
          <ChecklistIcon fontSize="small" />
          <span>{t("todo_lists")}</span>
        </Link>

        <Link to={`/${currentLang}/app/settings`} className={`abb-link ${isRouteActive("/app/settings") && !isRouteActive("/app/admin-settings") ? "abb-link-active" : ""}`}>
          <SettingsIcon fontSize="small" />
          <span>{t("settings")}</span>
        </Link>
      </div>
    </div>;
};
export default AppBottomBar;
